module.exports = __webpack_public_path__ + "static/media/Violation tooth angulation2.b4533ee9.png";